import * as Config from '../../../config';
import React from 'react';
import { useSelector } from "react-redux";
import './feedback.css';

import IconButtonFeedback from './svg/IconButtonFeedback';

function ButtonFeedback() {
  const user = useSelector(state => state.user);  
  const feedback = () => { 
    window.open(`${Config.F_FEEDBACK}&email=${user.email}&first_name=${user.firstname}`, `_blank`)
    /*
    let base = `${Config.F_FEEDBACK}&email=${user.email}&first_name=${user.firstname}&username=${user.name}`;
    if (window.location.href.includes('cart')) {
      window.open(`${base}&location=main_cart`, `_blank`);
    } 
    else if (window.location.href.includes('recommendations')) {
      window.open(`${base}&location=my_recommendations`, `_blank`);
    }
    else {
      window.open(`${base}&location=track_page&url=${window.location.href}`, `_blank`);
    }
    */
  }
  const feedbackGuest = () => { 
    window.open(`${Config.F_FEEDBACK_GUEST}`, `_blank`) 
    // window.open(`${Config.F_FEEDBACK_GUEST}&url=${window.location.href}`, `_blank`) 
  }
  const active = (user && user.email && user.firstname && user.email.length > 0);
  return (active && Config.F_FEEDBACK) ? (
    <div className={'button-fixed-feedback flexRow'} onClick={feedback}  >
      <IconButtonFeedback />
      <span className='type-medium fz15'>Feedback</span>
    </div>
  ) : ((!user && Config.F_FEEDBACK_GUEST) ? (
    <div className={'button-fixed-feedback flexRow'} onClick={feedbackGuest}  >
      <IconButtonFeedback />
      <span className='type-medium fz15'>Feedback</span>
    </div>
  ) : null);
}

export default ButtonFeedback;
